import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import isTradeUserSidebarOpenAtom from './isTradeUserSidebarOpenAtom';
const useOpenTradeUserSidebar = () => {
  const $ = _c(2);
  const setIsTradeUserSidebarOpen = useSetAtom(isTradeUserSidebarOpenAtom);
  let t0;
  if ($[0] !== setIsTradeUserSidebarOpen) {
    t0 = () => {
      setIsTradeUserSidebarOpen(true);
    };
    $[0] = setIsTradeUserSidebarOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const openTradeUserSidebar = t0;
  return openTradeUserSidebar;
};
export default useOpenTradeUserSidebar;